import React from 'react';
import { Link } from 'react-router-dom';

const FONT_BODY = "'Poppins', sans-serif";

export const CTA_BG = '#2E3192';
export const CTA_BG_HOVER = '#252775';

// The site's primary call-to-action look: solid indigo block, uppercase
// Poppins at 1px tracking, 6px radius. It lives in one place so the
// manufacturing CTA, the client-feedback submit button, and the product
// page's "Add to Order" button can never drift apart again.
export const ctaStyle = (extra = {}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '14px 32px',
  background: CTA_BG,
  color: '#fff',
  fontFamily: FONT_BODY,
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '1px',
  textTransform: 'uppercase',
  textDecoration: 'none',
  borderRadius: '6px',
  border: 'none',
  cursor: 'pointer',
  transition: 'background 0.2s',
  ...extra,
});

// Renders a react-router <Link> when `to` is given, otherwise a <button>.
export default function CtaButton({
  to,
  onClick,
  type = 'button',
  disabled = false,
  children,
  style,
  className = '',
  ...rest
}) {
  const shared = {
    style: ctaStyle(disabled ? { opacity: 0.6, cursor: 'not-allowed' } : style),
    className,
    onMouseEnter: (e) => {
      if (!disabled) e.currentTarget.style.background = CTA_BG_HOVER;
    },
    onMouseLeave: (e) => {
      if (!disabled) e.currentTarget.style.background = CTA_BG;
    },
    ...rest,
  };

  if (to) {
    return (
      <Link to={to} {...shared}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} disabled={disabled} {...shared}>
      {children}
    </button>
  );
}
